import { Divider, IconButton, InputBase, Paper, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import React, { useEffect, useState } from 'react';
import ReactFlagsSelect from "react-flags-select";
import { countryList } from './countryListData';
import regex from './regex';


const NumberInputFullWidth = ({ setCountryCode, mobileNumber, setMobileNumber, countryCode, isdisabled }) => {
  const [selected, setSelected] = useState("IN");
  const [mobileError, setMobileError] = useState(true);

  React.useEffect(() => {
    if (mobileNumber) {
      const isMobileValid = regex.numberPatternWithoutCode.test(mobileNumber)
      setMobileError(isMobileValid)
    }
  }, [mobileNumber])

  // React.useEffect(() => {
  //   if (countryCode) {
  //     setSelected(countryList.filter((item) => item.dial_code == countryCode)[0].code);
  //   }
  // }, [countryCode])

  useEffect(() => {
    setCountryCode(countryList.filter((item) => item.code === selected)[0].dial_code);
  }, [selected])

  return (
    <Box>
      <Paper
        component="form"
        sx={{ p: '2px 6px', display: 'flex', alignItems: 'center', borderRadius: '5px !important', border: '1px solid #D2D2D2', width: '100%', height: '3rem' }}
        elevation={0}
      >
        {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
          <MenuIcon />
        </IconButton> */}
        <ReactFlagsSelect
          selected={selected}
          onSelect={(code) => setSelected(code)}
          showOptionLabel={false}
          placeholder=" "
          style={{ width: '80px', height: '80px' }}
          showSelectedLabel={false}
          disabled={isdisabled}
        />
        <Divider sx={{ height: 28, m: 0.5, backgroundColor: '#000' }} orientation="vertical" />
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Enter Your Mobile Number"
          inputProps={{ 'aria-label': 'Enter Your Mobile Number' }}
          disabled={isdisabled}
          value={mobileNumber}
          onChange={(e) => {
            setMobileNumber(e.target.value)
          }}
        />
      </Paper>
      {!mobileError ? <p style={{ color: 'red', fontWeight: 'bold' }}>Invalid Input</p> : ""}

    </Box>

  );
}

export default NumberInputFullWidth;